module.exports = __webpack_public_path__ + "img/022.ed65f4c9.jpg";